module.exports = __webpack_public_path__ + "img/close.cc044e3c.svg";